import { useMemo } from 'react';
import TableComponent from '../../Common/Charts/TableCharts';
import { useProceduresChartsDataContext } from './hooks/useProceduresChartsDataContext';
import { number } from '../../Common/Util/number';

export const ProceduresTopTable = () => {
    const { chartData } = useProceduresChartsDataContext();

    const data = useMemo(() => {
        return (chartData?.top || [])
            .slice()
            .sort((a, b) => Number(b?.total || 0) - Number(a?.total || 0))
            .slice(0, 20);
    }, [chartData]);

    const tableColumns = [
        {
            key: 'descricao',
            header: 'Procedimento',
            headerStyle: { fontWeight: '700' },
            cellStyle: { fontWeight: '400' },
            formatter: (value) => value || 'Não informado'
        },
        {
            key: 'total',
            header: 'Total',
            headerStyle: {
                fontWeight: '700',
                textAlign: 'right'
            },
            cellStyle: {
                textAlign: 'right',
                fontWeight: '400'
            },
            formatter: (value) =>
                value != null
                    ? number.formatToBRNumber(value)
                    : 'Não informado'
        }
    ];

    return (
        <TableComponent
            className="no-spacing-table"
            data={data}
            columns={tableColumns}
            title="Top 20 Procedimentos Realizados"
            showTotal={false}
            maxHeight="700px"
        />
    );
};